/**
 * Copy del dialog di troncamento (FI-46bis). Esprime "perderai i livelli
 * L{editLevel+1}..L{originalLevel}" in modo leggibile (plurale/singolare).
 *
 * Estratta in un modulo a sé per rispettare la regola
 * `react-refresh/only-export-components` su `TruncateLevelsDialog.tsx`
 * (che esporta solo il componente React).
 */
export function truncateDescription(editLevel: number, truncatedLevels: number): string {
  if (truncatedLevels === 1) {
    return `Verranno cancellate le scelte del livello ${editLevel + 1}. Dovrai rifarle se vuoi tornare al livello attuale.`;
  }
  const lastTruncated = editLevel + truncatedLevels;
  return `Verranno cancellate le scelte dei livelli ${editLevel + 1}–${lastTruncated} (${truncatedLevels} livelli). Dovrai rifarli se vuoi tornare al livello attuale.`;
}
